import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer";
import ContentContainer from "../components/ContentContainer";
import SmallTitleText from "../components/SmallTitleText";
import UpdateBandForms from "../components/loggedin/UpdateBandForms";

const editBand = () => {
  return (
    <>
      <Layout
        title="Ändra musikprojeket"
        description="Ändra eller uppdatera dina uppgifter om projeket"
      >
        <MainContainer>
          <ContentContainer>
            <SmallTitleText text="Redigera ditt musikprojekt" />
            <p className="my-4">
              Här fyller du i den mest grundläggande informationen om ditt
              musikprojekt. Sen under Min profil kommer du kunna välja att lägga
              till mer information, starta blogg och länka till sociala medier
              m.m.
            </p>
            <div className="bg-base-300 border border-base-content/20 rounded-lg p-2 mt-2">
              <UpdateBandForms />
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default editBand;
